module.exports = __webpack_public_path__ + "static/media/tavoli.540b3a94.png";